export function ourMenuSlider() {
    //init slider
    const $slider = $(".menu-section .menu-gallery");
    const $settings = {
        arrows: false,
        fade: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplaySpeed: 500,
    };

    $slider.slick($settings);

    $('.menu-listing .tab-menu[data-slide]').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        var name = $(this).attr('aria-controls');
        $('.menu-listing .tab-menu').removeClass('active').attr('aria-selected', 'false');
        $(this).addClass('active').attr('aria-selected', 'true');
        $slider.slick('slickGoTo', slideno);
        $('.menu-tabs').hide().attr('hidden', true);
        //$('.tab-' + (slideno + 1)).show();
        $('#' + name).show().attr('hidden', false);
    });

    $('#locations li[data-location-id]').click(function (e) {
        e.preventDefault();
        var _id_location    = $(this).data('location-id');
        var _name           = $(this).find('button').data('data-name');
        $('.menu-listing .tab-menu').removeClass('active').attr('aria-selected', 'false');
        $('.menu-listing .tab-menu[data-slide="0"]').addClass('active');
        $slider.slick('slickGoTo', 0);
        $('.tabs-page:first-of-type').addClass('show');
        $('#locations li').removeClass('on').attr('aria-expanded', 'false');
        $('.wide-poster').removeClass('show').addClass('hide');
        $(this).addClass('on').attr('aria-expanded', 'true');
        $('.wide-poster[data-id="' + _id_location + '"]').removeClass('hide').addClass('show');

        $('.menu-listing .menu-tabs').attr('hidden', true);
        $('#' + _name +'-1').attr('hidden', false);

        $('.menu-tabs').hide();
        $('.tab-1').show();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/our-menu-slider.js